<template>
  <span style="margin-left: 10px;">
    <el-button type="primary" size="mini" @click="showInitBox"
      >设置直播间聊天</el-button
    >
    <el-dialog
      title="消息列表"
      :visible.sync="showInitBoxVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
    >
      <el-row>
        <el-input
          class="search-el"
          size="small"
          v-model="query.user_name"
          placeholder="用户昵称"
        ></el-input>
        <el-input
          class="search-el"
          size="small"
          v-model="query.content"
          placeholder="消息内容"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="getList()"
          :loading="listLoading"
        >
          查询
        </el-button>
        <el-divider direction="vertical"></el-divider>
        <el-tooltip
          class="item"
          effect="dark"
          :disabled="live_info.mock_live_fake_msg_count > 0 ? false : true"
          content="伪直播假聊天消息已添加到待发送列表，请从“已选中聊天消息”查看"
          placement="top"
        >
          <span>
            <el-button
              type="warning"
              size="small"
              @click="batchFakeMessage"
              :loading="batchFakeLoading"
              :disabled="live_info.mock_live_fake_msg_count > 0 ? true : false"
              >全部添加待发送</el-button
            >
          </span>
        </el-tooltip>
        <el-divider direction="vertical"></el-divider>
        <el-tooltip
          class="item"
          effect="dark"
          :disabled="total > 0 ? false : true"
          content="该伪直播的 原始直播的消息已经拉取到本地消息库，禁止重复拉取。请添加待发送，并从“已选中聊天消息”查看"
          placement="top"
        >
          <span>
            <el-button
              type="warning"
              size="small"
              @click="initLiveChatMessage"
              :loading="initLoading"
              :disabled="total > 0 ? true : false"
              >拉取全部聊天记录</el-button
            >
          </span>
        </el-tooltip>
      </el-row>
      <el-row v-loading="listLoading">
        <el-table
          :data="list"
          border
          size="mini"
          :stripe="true"
          height="500"
          style="width: 100%; margin: 20px 0;"
        >
          <el-table-column
            prop="user_id"
            label="用户ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="user_name"
            label="用户昵称"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="用户头像" align="center">
            <template slot-scope="{ row }">
              <el-image
                style="width: 40px; height: 40px;"
                :src="row.user_avatar"
                :preview-src-list="[row.user_avatar]"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户角色" align="center">
            <template slot-scope="{ row }">
              <span>{{
                row.user_role == 0
                  ? "学生"
                  : row.user_role == 1
                  ? "老师"
                  : "助教"
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="内容"
            align="center"
            width="260"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <span v-if="row.content_type == 1">{{ row.content }}</span>
              <span
                v-else-if="row.content_type == 2"
                class="demo-image__preview"
              >
                <el-image
                  style="width: 45px; height: 45px;"
                  :src="row.content"
                  :preview-src-list="[row.content]"
                  fit="cover"
                ></el-image>
              </span>
              <span v-else style="display: flex; justify-content: center;">
                <span>
                  <el-image
                    style="width: 45px; height: 45px;"
                    :src="row.content.image"
                    :preview-src-list="[row.content.image]"
                    fit="cover"
                  ></el-image>
                </span>
                <span
                  style="
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    padding-left: 5px;
                  "
                >
                  <span
                    style="
                      width: 180px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                    >{{ row.content.title }}</span
                  >
                  <span
                    ><a :href="row.content.address" target="_blank"
                      >查看详情</a
                    ></span
                  >
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发送时间" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.relative_send_time < 0" style="color: #ff0000;"
                >开播前</span
              >
              <span v-if="row.relative_send_time >= 0" style="color: #67c23a;"
                >开播后</span
              >
              {{ formatSecondShow(row.relative_send_time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="past_send_time"
            label="原发送时间"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="new_send_time"
            label="新发送时间"
            align="center"
            width="150"
          ></el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <div class="block">
          <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import {
  initLiveChatMessage,
  getLiveChatMessage,
  batchFakeMessage,
  fakeMessage,
  deleteInitFakeMessage,
} from "@/api/live";
import { formatSeconds } from "@/api/common";

export default {
  name: "initLiveChatMessage",
  props: {
    period_id: {
      type: String,
      default: "",
    },
    live_info: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showInitBoxVisible: false,
      listLoading: false,
      initLoading: false,
      batchFakeLoading: false,
      query: {
        page: 1,
        //limit: 10000,
        limit: 20,
        user_name: "",
        content: "",
        content_type: "",
        message_status: "",
      },
      list: [],
      total: 0,
    };
  },
  methods: {
    deleteInitFakeMessage(id, row) {
      row.del_fake_loding = true;
      deleteInitFakeMessage({
        message_id: id,
      }).then((res) => {
        if (res.status == 2000) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: "操作成功",
            type: "success",
          });
          row.del_fake_loding = false;
          row.message_status = 1;
        }
      });
    },
    formatSecondShow(second) {
      return formatSeconds(Math.abs(second));
    },
    batchFakeMessage() {
      if (this.total == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "请先拉取聊天记录",
          type: "warn",
        });
        return;
      }
      this.batchFakeLoading = true;
      this.listLoading = true;

      this.$confirm("确定全部添加待发送？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          batchFakeMessage(this.query).then((res) => {
            this.batchFakeLoading = false;
            if (res.status == 2000) {
              this.$message({
                showClose: true,
                duration: 3000,
                message:
                  "伪直播假聊天消息已添加到待发送列表，请从“已选中聊天消息”查看",
                type: "success",
              });
              this.live_info.mock_live_fake_msg_count = 1;
              this.batchFakeLoading = false;
              this.listLoading = false;
            }
          });
        })
        .catch(() => {
          this.batchFakeLoading = false;
          this.listLoading = false;
        });
    },
    fakeMessage(id, row) {
      row.fake_loding = true;
      fakeMessage({
        message_id: id,
      }).then((res) => {
        if (res.status == 2000) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: "操作成功",
            type: "success",
          });
          row.fake_loding = false;
          row.message_status = 2;
        }
      });
    },
    getList() {
      this.query.period_id = this.period_id;
      this.query.mock_period_id = this.live_info.configuration.mock_course_period_id;
      this.query.mock_bjy_video_id = this.live_info.configuration.mock_bjy_video_id;
      this.listLoading = true;
      getLiveChatMessage(this.query).then((res) => {
        this.list = res.data.list.map((item) => {
          item.fake_loding = false;
          item.del_fake_loding = false;
          // 图片消息
          if (item.content_type == 2) {
            item.content = item.content.replace("[img:", "").replace("]", "");
          }
          // 自定义消息
          if (item.content_type == 3) {
            item.content = JSON.parse(
              item.content.replace("#zhangdefenspace#", "")
            );
          }
          return item;
        });
        this.total = res.data.total;
        this.listLoading = false;
      });
    },
    showInitBox() {
      if (
        this.live_info.configuration.mock_live_msg_source == undefined ||
        this.live_info.configuration.mock_live_msg_source == 0
      ) {
        this.$message({
          showClose: true,
          message: "该直播使用的“直播原消息”，无需手动设置消息内容",
          type: "warning",
        });
      } else {
        this.getList();
        this.showInitBoxVisible = true;
      }
    },
    initLiveChatMessage() {
      this.$confirm(
        "该操作将从百家云拉取该伪直播的 原始直播的消息到本地消息库，是否确认？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.initLoading = true;
        initLiveChatMessage({
          period_id: this.period_id,
          mock_period_id: this.live_info.configuration.mock_course_period_id,
          mock_bjy_video_id: this.live_info.configuration.mock_bjy_video_id,
        }).then((res) => {
          this.initLoading = false;
          if (res.status == 2000) {
            this.$message({
              showClose: true,
              duration: 6000,
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        });
      });
    },
  },
};
</script>

<style scoped></style>
